<div class="mia-config">

  <!-- Cabeçalho fixo: identidade e estado. A pílula fica visível nas duas abas —
       quem mexe nos ajustes precisa saber que a Mia está desligada sem trocar de aba. -->
  <div class="mia-topo">
    <header class="mia-header" [attr.data-estado]="estadoAtual.chave">
      <div class="mia-header__identidade">
        <span class="mia-avatar"><i class="fas fa-robot"></i></span>
        <div>
          <h1 class="mia-header__titulo">
            {{ configuracoes.nome || 'Mia' }}
            <span class="mia-header__selo">Configurações avançadas</span>
          </h1>
          <p class="mia-header__sub">Ajustes por etapa do pedido e assuntos do atendimento.</p>
        </div>
      </div>

      <div class="mia-header__estado">
        <span class="mia-pill" [attr.data-estado]="estadoAtual.chave">
          <span class="mia-pill__dot"></span>{{ estadoAtual.rotulo }}
        </span>
        <button type="button" class="mia-link" (click)="mostrarRecursos = !mostrarRecursos"
                [attr.aria-expanded]="mostrarRecursos" aria-controls="mia-recursos">
          <i class="far fa-question-circle"></i>
          O que a Mia faz?
        </button>
      </div>
    </header>
  </div>

  <div class="mia-alerta-canal" role="alert" *ngIf="statusMiaV3 && !statusMiaV3.canalWhatsappAtivo">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <div>
      <strong>Mia V3 não está ativa no WhatsApp</strong>
      <p *ngIf="!statusMiaV3.canaisWhatsapp?.length">Nenhum canal disponível. Conecte a API oficial ou a extensão V4 com suporte a eventos.</p>
      <ul *ngIf="statusMiaV3.canaisWhatsapp?.length">
        <li *ngFor="let canal of statusMiaV3.canaisWhatsapp">{{ canal.detalhe }}</li>
      </ul>
    </div>
  </div>

  <div class="mia-alerta-canal" role="status" *ngIf="erroStatusMiaV3">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <span>Não foi possível verificar a conexão do WhatsApp da Mia V3. Recarregue a página para consultar novamente.</span>
  </div>

  <!-- Lista de capacidades: ajuda, não vitrine. Fechada por padrão. -->
  <section class="mia-recursos" id="mia-recursos" *ngIf="mostrarRecursos">
    <p class="mia-recursos__intro">A Mia atende sozinha estas situações, direto no WhatsApp:</p>
    <ul class="mia-recursos__lista">
      <li><i class="fas fa-check"></i><span><strong>Ajuda a fazer pedidos</strong> pela conversa quando o carrinho conversacional está habilitado; nos demais casos, direciona ao cardápio digital.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Envia o cardápio</strong> por link, imagem ou ambos, conforme a configuração.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Informa</strong> sobre os itens disponíveis, sem o cliente sair da conversa.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Consulta o status</strong> dos pedidos.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Divulga promoções</strong>, cupons e ofertas especiais.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Responde horários</strong> de funcionamento da loja.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Informa o endereço</strong> da loja.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Tira dúvidas</strong> dos clientes sobre o estabelecimento.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Atende na hora</strong>, sem fila de espera, a qualquer momento do dia.</span></li>
    </ul>
  </section>

  <!-- Duas tarefas, duas abas: OPERAÇÃO (ligar, testar, demonstrar) e AJUSTES (como
       ela atende). Quem entra aqui vem por uma delas, raramente pelas duas. Os
       ajustes continuam numa página só, com trilho e busca — a aba separa tarefas,
       não esconde ajustes uns dos outros. -->
  <nav class="mia-abas" role="tablist" aria-label="Partes da configuração da Mia">
    <button type="button" class="mia-aba" role="tab" *ngFor="let aba of abas"
            [id]="'mia-aba-' + aba.chave"
            [class.mia-aba--ativa]="abaAtiva === aba.chave"
            [attr.aria-selected]="abaAtiva === aba.chave"
            [attr.aria-controls]="'mia-painel-' + aba.chave"
            (click)="selecioneAba(aba.chave)">
      <i class="fas" [ngClass]="aba.icone"></i>
      <span>{{ aba.rotulo }}</span>
      <span class="mia-aba__conta" *ngIf="aba.chave === 'ajustes'">{{ totalEncontrado }}</span>
    </button>
  </nav>

  <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}" (ngSubmit)="onSubmit()"
        novalidate #frm="ngForm">

    <!-- OPERAÇÃO: ligar, testar e demonstrar. Não é ajuste de como a Mia atende, é
         quem recebe resposta dela — por isso aba própria. Estado e telefones ficam
         fora do filtro: a busca altera somente .mia-corpo. -->
    <div class="mia-operacao" id="mia-painel-operacao" role="tabpanel" aria-labelledby="mia-aba-operacao"
         [class.mia-oculto]="abaAtiva !== 'operacao'">

      <section class="mia-cartao">
        <header class="mia-cartao__head">
          <span class="mia-cartao__icone"><i class="fas fa-power-off"></i></span>
          <div class="mia-cartao__texto">
            <h2 class="mia-cartao__titulo">Estado de operação</h2>
            <p class="mia-cartao__desc">Defina quem recebe e conversa com a Mia no WhatsApp agora.</p>
          </div>
          <span class="mia-selo-cartao mia-selo-cartao--teste" *ngIf="configuracoes.status === 'MODO_TESTE'">
            Recomendado para começar
          </span>
        </header>

        <p class="mia-aviso mia-aviso--desligada" *ngIf="!ehSuperadmin">
          <i class="fas fa-lock"></i>
          <span>Só o superadmin do MeuCardápio pode ativar a Mia (Modo Teste ou Em Produção). Você pode desligá-la a qualquer momento.</span>
        </p>

        <div class="mia-modos" role="radiogroup" aria-label="Estado de operação">
          <label class="mia-modo" *ngFor="let opcao of opcoesStatus" [attr.data-estado]="opcao.valor"
                 [class.mia-modo--ativo]="configuracoes.status === opcao.valor"
                 [class.mia-modo--travado]="estadoBloqueado(opcao.valor)">
            <input type="radio" class="mia-modo__input" [id]="'rbStatus' + opcao.valor"
                   name="estado-mia" [value]="opcao.valor" [disabled]="estadoBloqueado(opcao.valor)"
                   [(ngModel)]="configuracoes.status" (ngModelChange)="atualizeBusca()"/>
            <span class="mia-modo__corpo">
              <span class="mia-modo__topo">
                <span class="mia-modo__icone"><i class="fas" [ngClass]="opcao.icone"></i></span>
                <span class="mia-modo__radio" aria-hidden="true"></span>
              </span>
              <span class="mia-modo__nome">
                {{ opcao.nome }}
                <span class="mia-modo__tag" *ngIf="configuracoes.status === opcao.valor">Ativo</span>
              </span>
              <span class="mia-modo__desc">{{ opcao.descricao }}</span>
            </span>
          </label>
        </div>

        <p class="mia-nota-estado" *ngIf="opcaoStatus">
          <i class="far fa-info-circle"></i>
          <span>{{ opcaoStatus.descricao }}<strong *ngIf="opcaoStatus.reforco"> {{ opcaoStatus.reforco }}</strong></span>
        </p>
      </section>

      <section class="mia-cartao" *ngIf="configuracoes.status === 'MODO_TESTE'">
        <header class="mia-cartao__head">
          <span class="mia-cartao__icone mia-cartao__icone--verde"><i class="fas fa-phone"></i></span>
          <div class="mia-cartao__texto">
            <h2 class="mia-cartao__titulo">Telefones liberados para teste</h2>
            <p class="mia-cartao__desc">Digite com DDI + DDD + número. Exemplo: {{ exemploTelefone }}</p>
          </div>
          <span class="mia-selo-cartao">{{ telefones.length }} {{ telefones.length === 1 ? 'número cadastrado' : 'números cadastrados' }}</span>
        </header>

        <p class="mia-rotulo-lista">Números com acesso liberado</p>
        <div class="mia-fichas" *ngIf="telefones.length; else semTelefones">
          <span class="mia-ficha mia-ficha--telefone" *ngFor="let telefone of telefones">
            {{ formateTelefone(telefone) }}
            <button type="button" class="mia-ficha__x" (click)="removaTelefone(telefone)"
                    [attr.aria-label]="'Remover ' + telefone">
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>
        <ng-template #semTelefones>
          <p class="mia-hint">Nenhum número ainda. Coloque o seu e o da equipe para experimentar antes de liberar para os clientes.</p>
        </ng-template>

        <div class="mia-add">
          <span class="mia-add__campo">
            <i class="fas fa-plus" aria-hidden="true"></i>
            <input type="text" class="form-control" id="novo-telefone" name="novoTelefone"
                   [(ngModel)]="novoTelefone" [ngModelOptions]="{standalone: true}"
                   [placeholder]="'Ex: ' + exemploTelefone" inputmode="numeric"
                   (keydown.enter)="$event.preventDefault(); adicioneTelefone()"/>
          </span>
          <button type="button" class="mia-add__btn" (click)="adicioneTelefone()">
            <i class="fas fa-plus"></i> Adicionar número
          </button>
        </div>
      </section>

      <!-- DEMONSTRAÇÃO. Ferramenta de teste, não conduta da Mia. -->
      <section class="mia-cartao" *ngIf="statusMiaV3?.recursoMiaV3Ativo">
        <header class="mia-cartao__head">
          <span class="mia-cartao__icone"><i class="fas fa-comment-dots"></i></span>
          <div class="mia-cartao__texto">
            <h2 class="mia-cartao__titulo">Link de demonstração</h2>
            <p class="mia-cartao__desc">Página pública onde o cliente testa a Mia no celular, sem login — envie o link e deixe a Mia vender por você.</p>
          </div>
        </header>

        <div class="mia-widget__linha" *ngIf="widgetUrl">
          <input class="mia-widget__url" type="text" readonly [value]="widgetUrl" (focus)="$any($event.target).select()"/>
          <button type="button" class="mia-widget__btn" (click)="copieLinkWidget()"
                  [class.mia-widget__btn--ok]="widgetCopiado">
            <i class="fas" [ngClass]="widgetCopiado ? 'fa-check' : 'fa-copy'"></i>
            {{ widgetCopiado ? 'Copiado!' : 'Copiar link' }}
          </button>
          <a class="mia-widget__btn mia-widget__btn--claro" [href]="widgetUrl" target="_blank"
             title="Abrir o widget numa aba nova">
            <i class="fas fa-external-link-alt"></i>
          </a>
        </div>

        <p class="mia-hint" *ngIf="widgetCarregando">Carregando o link…</p>
        <p class="mia-widget__erro" *ngIf="widgetErro">⚠️ {{ widgetErro }}</p>

        <div class="mia-widget__rodape" *ngIf="widgetUrl">
          <p class="mia-hint">
            Qualquer pessoa com o link conversa com a Mia usando o cardápio desta loja.
            As conversas aparecem na tela de conversas identificadas como <strong>Widget</strong>.
          </p>
          <button type="button" class="mia-link mia-link--perigo" (click)="regenereTokenWidget()"
                  [disabled]="regenerandoWidget">
            <i class="fas fa-sync-alt"></i>
            {{ regenerandoWidget ? 'Regenerando…' : 'Regenerar link (invalida o atual)' }}
          </button>
        </div>
      </section>

      <!-- CHECKLIST DE ATIVAÇÃO (admin). É operação — o que falta para a Mia V3
           atender de verdade —, não ajuste. -->
      <section class="mia-cartao" *ngIf="ehAdminMeuCardapio && statusMiaV3">
        <header class="mia-cartao__head">
          <span class="mia-cartao__icone"><i class="fas fa-tasks"></i></span>
          <div class="mia-cartao__texto">
            <h2 class="mia-cartao__titulo">Checklist de ativação</h2>
            <p class="mia-cartao__desc">O que ainda falta para a Mia V3 atender de verdade nesta loja.</p>
          </div>
          <span class="mia-selo-cartao" [class.mia-selo-cartao--ok]="checklistCompleto">
            {{ checklistProntos }} de {{ itensChecklistMiaV3.length }} prontos
          </span>
          <button type="button" class="mia-checklist__recarregar" (click)="carregueStatusMiaV3()" title="Reconsultar"
                  aria-label="Reconsultar o checklist">
            <i class="fas fa-sync-alt"></i>
          </button>
        </header>

        <div class="mia-checklist__barra" [class.mia-checklist__barra--completa]="checklistCompleto">
          <span [style.width.%]="checklistPercentual"></span>
        </div>

        <ul class="mia-checklist__lista">
          <li class="mia-checklist__item" *ngFor="let item of itensChecklistMiaV3"
              [class.mia-checklist__item--ok]="item.ok">
            <span class="mia-checklist__marca">
              <i class="fas" [ngClass]="item.ok ? 'fa-check' : 'fa-exclamation'"></i>
            </span>
            <span>
              <strong>{{ item.rotulo }}</strong>
              <small *ngIf="item.detalhe">{{ item.detalhe }}</small>
            </span>
          </li>
        </ul>

        <p class="mia-hint">O checklist reflete o que está salvo — depois de mudar o motor, salve e reconsulte.</p>
      </section>
    </div>

    <div id="mia-painel-ajustes" role="tabpanel" aria-labelledby="mia-aba-ajustes"
         [class.mia-oculto]="abaAtiva !== 'ajustes'">

    <!-- Atalho para a tela "Jeito de atender": a mesma configuração lida em texto
         corrido, com busca. Quem prefere ler a Mia em vez de percorrer ajustes vai
         por ali; esta tela continua sendo a de ajuste a ajuste. -->
    <div class="mia-atalho">
      <span class="mia-atalho__icone"><i class="fas fa-book-open"></i></span>
      <div class="mia-atalho__texto">
        <strong>Prefere ler como a Mia atende?</strong>
        <span>A tela Jeito de atender mostra esta mesma configuração em texto corrido, e cada frase abre o ajuste que a controla.</span>
      </div>
      <button type="button" class="mia-atalho__btn" (click)="abraJeitoDeAtender()">
        Abrir Jeito de atender <i class="fas fa-arrow-right"></i>
      </button>
    </div>

    <p class="mia-aviso mia-aviso--desligada" *ngIf="miaDesligada">
      <i class="fas fa-info-circle"></i>
      <span>A Mia está desligada: os ajustes abaixo continuam salvos, mas nenhum cliente recebe resposta dela
        enquanto o estado não virar <strong>Modo Teste</strong> ou <strong>Em Produção</strong>.
        <button type="button" class="mia-link" (click)="selecioneAba('operacao')">Ir para Operação</button></span>
    </p>

    <div class="mia-corpo">

      <!-- Trilho: o mapa inteiro da tela visível de uma vez, com quantos ajustes
           cada momento tem. É o que a aba nunca deu — saber onde a coisa mora. -->
      <nav class="mia-trilho" aria-label="Momentos da conversa">
        <!-- a busca filtra o trilho: mora dentro dele, e como o trilho é grudado
             ela continua ao alcance no meio da rolagem — na faixa do topo ela
             sumia justamente quando o lojista estava longe do começo -->
        <div class="mia-busca" role="search">
          <i class="fas fa-search mia-busca__icone" aria-hidden="true"></i>
          <input type="search" class="mia-busca__campo" id="mia-busca" name="miaBusca"
                 [(ngModel)]="busca" [ngModelOptions]="{standalone: true}" (ngModelChange)="atualizeBusca()"
                 placeholder="Buscar ajuste…"
                 aria-label="Buscar ajuste da Mia — áudio, troco, cardápio, lembrete"/>
          <button type="button" class="mia-busca__limpar" *ngIf="buscando" (click)="limpeBusca()"
                  aria-label="Limpar busca">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Dois blocos: os passos do pedido, na ordem, e o que vale a conversa toda.
             Buscando, a divisão some: o que importa é onde o resultado mora. -->
        <ng-container *ngIf="!buscando; else encontrados">
          <div class="mia-trilho__blocos">
            <div class="mia-trilho__bloco" *ngFor="let bloco of blocos">
              <p class="mia-trilho__rotulo">{{ bloco.rotulo }}</p>
              <ng-container *ngTemplateOutlet="itens; context: {lista: bloco.secoes}"></ng-container>
            </div>
          </div>
        </ng-container>
        <ng-template #encontrados>
          <p class="mia-trilho__rotulo">Encontrado em</p>
          <ng-container *ngTemplateOutlet="itens; context: {lista: secoes}"></ng-container>
        </ng-template>
        <ng-template #itens let-lista="lista">
          <div class="mia-trilho__lista">
            <button type="button" class="mia-trilho__item" *ngFor="let secao of lista; trackBy: trackPorChave"
                    [class.mia-trilho__item--ativo]="secaoAtiva === secao.chave"
                    [attr.aria-current]="secaoAtiva === secao.chave ? 'true' : null"
                    (click)="vaParaSecao(secao.chave)">
              <span class="mia-trilho__marca"><i class="fas" [ngClass]="secao.icone"></i></span>
              <span class="mia-trilho__nome">{{ secao.rotulo }}</span>
              <!-- a contagem por seção já é o resultado da busca: um total separado
                   em cima do campo seria a mesma informação dita duas vezes -->
              <span class="mia-trilho__conta">{{ contagemDaSecao(secao) }}</span>
            </button>
          </div>
        </ng-template>
      </nav>

      <div class="mia-secoes mia-ajustes">

        <div class="mia-painel" *ngFor="let resultado of resultadosBloqueados">
          <h3 class="mia-painel__titulo">{{ resultado.rotulo }}</h3>
          <p class="mia-hint">{{ resultado.mensagem }}</p>
          <button type="button" class="mia-link" *ngIf="resultado.alvo" (click)="abraCampo(resultado.alvo)">
            Ir ao ajuste necessário
          </button>
        </div>

        <section class="mia-secao" *ngFor="let secao of secoesDaTela; trackBy: trackPorChave"
                 [class.mia-oculto]="!secaoNaTela(secao.chave)"
                 [id]="'mia-secao-' + secao.chave" [attr.aria-labelledby]="'mia-titulo-' + secao.chave">
          <div class="mia-secao__head">
            <span class="mia-secao__num"><i class="fas" [ngClass]="secao.icone"></i></span>
            <div>
              <h2 class="mia-secao__titulo" [id]="'mia-titulo-' + secao.chave">{{ secao.rotulo }}</h2>
              <p class="mia-secao__desc">{{ secao.desc }}</p>
            </div>
          </div>
          <ng-container [ngSwitch]="secao.chave">
            <ng-container *ngSwitchCase="'chegada'">
<div class="mia-bloco">
            <div class="mia-campo" [class.mia-oculto]="!chavesVisiveis.has('nome')">
              <label for="chatbot-name" class="mia-label mia-label--cap">Nome da atendente</label>
              <input type="text" class="form-control" id="chatbot-name" name="Mia" kendoTextBox #nome="ngModel"
                     [(ngModel)]="configuracoes.nome" required="true" minlength="3"/>
              <p class="mia-hint">Nome exibido na saudação inicial (Ex: "Olá! Sou a Mia, atendente do estabelecimento").</p>
              <div class="invalid-feedback">
                <span *ngIf="nome.errors?.required">Informe o nome da Mia.</span>
                <span *ngIf="nome.errors?.minlength">Use pelo menos 3 letras no nome da Mia.</span>
              </div>
            </div>

            <div class="mia-linha" [class.mia-oculto]="!chavesVisiveis.has('personalizarSaudacao')">
              <div class="mia-linha__texto">
                <label for="personalizarSaudacao" class="mia-label"><i class="fas fa-user-check"></i> Reconhecer o cliente na saudação</label>
                <p class="mia-hint">Cliente que já pediu é cumprimentado pelo nome, sem a apresentação completa da Mia, como
                  quem reconhece cliente da casa. Desligado, todo mundo recebe a saudação de primeira visita.</p>
              </div>
              <kendo-switch id="personalizarSaudacao" name="personalizarSaudacao"
                            [(ngModel)]="configuracoes.personalizarSaudacao"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>


            <div class="mia-linha" *ngIf="configuracoes.carrinhoMiaV3"
                 [class.mia-oculto]="!chavesVisiveis.has('repetirPedido')">
              <div class="mia-linha__texto">
                <label for="repetirPedido" class="mia-label"><i class="fas fa-redo"></i> Oferecer repetir o último pedido</label>
                <p class="mia-hint">Ao reconhecer um cliente que já pediu, a Mia oferece repetir o último pedido com os preços
                  de hoje e atende “o de sempre”. Desligue se o cardápio muda todo dia (ex.: marmitaria com prato do dia):
                  a Mia cumprimenta pelo nome e convida a ver o cardápio de hoje.</p>
              </div>
              <kendo-switch id="repetirPedido" name="repetirPedido"
                            [(ngModel)]="configuracoes.repetirPedido"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>
          </div>
            </ng-container>
            <ng-container *ngSwitchCase="'conversa'">
<div class="mia-bloco" [class.mia-oculto]="!chavesVisiveis.has('conversaCurta')"><div class="mia-linha" *ngIf="configuracoes.carrinhoMiaV3"
                 [class.mia-oculto]="!chavesVisiveis.has('conversaCurta')">
              <div class="mia-linha__texto">
                <label for="conversaCurta" class="mia-label"><i class="fas fa-comment"></i> Conversa curta</label>
                <p class="mia-hint">A Mia responde com poucas palavras, mostra os itens e o total em uma linha e
                  pergunta “Algo mais?”. Quando o cliente diz “só isso”, segue para o fechamento sem perguntar
                  de novo. O cliente continua revisando o pedido antes de confirmar.</p>
              </div>
              <kendo-switch id="conversaCurta" name="conversaCurta"
                            [(ngModel)]="configuracoes.conversaCurta"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div></div>
<div class="mia-bloco mia-bloco--medido" [class.mia-oculto]="!chavesVisiveis.has('comportamentoAudio')
                 && !chavesVisiveis.has('entenderImagens')">

            <fieldset class="mia-opcoes" [class.mia-oculto]="!chavesVisiveis.has('comportamentoAudio')">
              <legend class="mia-label"><i class="fas fa-microphone mia-opcoes__icone"></i> Quando o cliente manda áudio</legend>
              <p class="mia-hint mia-hint--escolha">Escolha o que a Mia faz quando um áudio chegar.</p>

              <div class="mia-chips">
                <label class="mia-opcao mia-opcao--chip" *ngFor="let opcao of opcoesAudio">
                  <input type="radio" class="mia-opcao__input" [id]="'rbAudio' + opcao.valor"
                         name="comportamentoAudio" [value]="opcao.valor"
                         [(ngModel)]="configuracoes.comportamentoAudio"/>
                  <span class="mia-opcao__corpo">
                    <span class="mia-opcao__marca"></span>
                    <span>
                      <span class="mia-opcao__nome"><i class="fas" [ngClass]="opcao.icone"></i> {{ opcao.nome }}</span>
                      <span class="mia-opcao__desc">{{ opcao.descricao }}<strong *ngIf="opcao.reforco"> {{ opcao.reforco }}</strong></span>
                    </span>
                  </span>
                  <span class="mia-dica" role="tooltip">{{ dicaDaOpcao(opcao) }}</span>
                </label>
              </div>

              <p class="mia-escolhido" *ngIf="opcaoAudio">
                <span>{{ opcaoAudio.descricao }}<strong *ngIf="opcaoAudio.reforco"> {{ opcaoAudio.reforco }}</strong></span>
              </p>


              <p class="mia-aviso" *ngIf="!configuracoes.escalarParaAtendente">
                <i class="fas fa-info-circle"></i>
                <span>Nos modos “Pedir para escrever” e “Chamar um atendente”, a Mia pede texto uma vez e fica em silêncio
                  na insistência quando a transferência está desligada.
                  <button type="button" class="mia-atalho__link" (click)="abraCampo('escalarParaAtendente')">Ajustar ajuda da equipe</button></span>
              </p>
            </fieldset>

            <div class="mia-linha" [class.mia-oculto]="!chavesVisiveis.has('entenderImagens')">
              <div class="mia-linha__texto">
                <label for="entenderImagens" class="mia-label"><i class="fas fa-image"></i> Entender as imagens do cliente</label>
                <p class="mia-hint">A Mia lê a imagem que o cliente manda (foto de um produto, print, comprovante) e
                  responde sobre ela. Desligado, a imagem continua aparecendo na conversa do painel para a sua equipe,
                  mas a Mia não tenta interpretar o conteúdo.</p>
              </div>
              <kendo-switch id="entenderImagens" name="entenderImagens"
                            [(ngModel)]="configuracoes.entenderImagens"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>
          </div>
<div class="mia-bloco" *ngIf="ehAdminMeuCardapio" [class.mia-oculto]="!chavesVisiveis.has('instrucoesDaLoja')">
              <label for="instrucoes-da-loja" class="mia-label mia-label--cap">Instruções da loja <span class="mia-tag">admin</span></label>
              <textarea class="form-control" id="instrucoes-da-loja" name="instrucoesDaLoja" rows="4" maxlength="1500"
                        [(ngModel)]="configuracoes.instrucoesDaLoja"
                        placeholder="Ex.: A loja é tratada no masculino: 'o Empório', 'no Empório'. Nunca ofereça bebida alcoólica junto de pedidos de almoço."></textarea>
              <p class="mia-hint">Particularidades desta loja que a Mia deve seguir: tratamento do nome, tom regional,
                restrições de oferta. Entram no prompt como instruções de estilo — as regras de segurança
                (nunca inventar itens, preços ou prazos) continuam valendo por cima.</p>
            </div>
            </ng-container>
            <ng-container *ngSwitchCase="'descoberta'">
<div class="mia-bloco" [class.mia-oculto]="!chavesVisiveis.has('divulgarLinkCardapio') && !chavesVisiveis.has('entregaCardapio')
                 && !chavesVisiveis.has('imagemCardapioSoDoDia') && !chavesVisiveis.has('rotuloBotaoCardapio')
                 && !chavesVisiveis.has('rodapeBotaoCardapio')">
<div class="mia-linha" [class.mia-oculto]="!chavesVisiveis.has('divulgarLinkCardapio')">
              <div class="mia-linha__texto">
                <label for="divulgarLinkCardapio" class="mia-label"><i class="fas fa-link"></i> Divulgar o link do cardápio</label>
                <p class="mia-hint">A Mia envia o link do cardápio digital já na primeira vez que o cliente quer ver o
                  cardápio, junto das categorias — e a saudação menciona esse caminho. Desligado, o link só vai quando o
                  cliente pede explicitamente.</p>
              </div>
              <kendo-switch id="divulgarLinkCardapio" name="divulgarLinkCardapio"
                            [(ngModel)]="configuracoes.divulgarLinkCardapio"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>

            <fieldset class="mia-opcoes">
              <legend class="mia-label"><i class="far fa-image"></i> Quando o cliente pede o cardápio</legend>
              <p class="mia-hint mia-hint--escolha">A imagem é a mesma do botão “Enviar Imagem do Cardápio”, cadastrada em
                Cardápio. Sem imagem cadastrada, a Mia envia o link.</p>

              <div class="mia-chips">
                <label class="mia-opcao mia-opcao--chip" *ngFor="let opcao of opcoesEntregaCardapio">
                  <input type="radio" class="mia-opcao__input" [id]="'rbEntregaCardapio' + opcao.valor"
                         name="entregaCardapio" [value]="opcao.valor"
                         [(ngModel)]="configuracoes.entregaCardapio" (ngModelChange)="atualizeBusca()"/>
                  <span class="mia-opcao__corpo">
                    <span class="mia-opcao__marca"></span>
                    <span>
                      <span class="mia-opcao__nome"><i class="fas" [ngClass]="opcao.icone"></i> {{ opcao.nome }}</span>
                      <span class="mia-opcao__desc">{{ opcao.descricao }}<strong *ngIf="opcao.reforco"> {{ opcao.reforco }}</strong></span>
                    </span>
                  </span>
                  <span class="mia-dica" role="tooltip">{{ dicaDaOpcao(opcao) }}</span>
                </label>
              </div>
            </fieldset>

            <div class="mia-filhos" *ngIf="configuracoes.entregaCardapio && configuracoes.entregaCardapio !== 'LINK'">
              <div class="mia-linha mia-linha--limpa">
                <div class="mia-linha__texto">
                  <label for="imagemCardapioSoDoDia" class="mia-label"><i class="fas fa-calendar-day"></i> Só enviar a imagem se ela foi atualizada hoje</label>
                  <p class="mia-hint">Para cardápio do dia (marmitaria, prato feito). Se a imagem não foi trocada hoje,
                    a Mia envia o link no lugar da foto — nunca a foto de ontem.</p>
                </div>
                <kendo-switch id="imagemCardapioSoDoDia" name="imagemCardapioSoDoDia"
                              [(ngModel)]="configuracoes.imagemCardapioSoDoDia"
                              [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
              </div>
            </div>


            <div class="mia-filhos">
              <div>
                <label for="rotuloBotaoCardapio" class="mia-label mia-label--contada">
                  <span>Texto do botão do cardápio (opcional)</span>
                  <span class="mia-contador">{{ (configuracoes.rotuloBotaoCardapio || '').length }}/20</span>
                </label>
                <p class="mia-hint">Texto do botão que abre o cardápio online nas mensagens da Mia. Em branco vale o
                  padrão "Fazer Pedido". Máximo de 20 caracteres (limite do WhatsApp).</p>
                <input type="text" class="form-control" id="rotuloBotaoCardapio" name="rotuloBotaoCardapio" maxlength="20"
                       [(ngModel)]="configuracoes.rotuloBotaoCardapio" placeholder="Fazer Pedido"/>
              </div>
              <div>
                <label for="rodapeBotaoCardapio" class="mia-label mia-label--contada">
                  <span>Frase de apoio do botão (opcional)</span>
                  <span class="mia-contador">{{ (configuracoes.rodapeBotaoCardapio || '').length }}/60</span>
                </label>
                <p class="mia-hint">Frase pequena que aparece entre o texto da mensagem e o botão. Em branco vale o
                  padrão "Toque no botão para fazer seu pedido". Máximo de 60 caracteres.</p>
                <input type="text" class="form-control" id="rodapeBotaoCardapio" name="rodapeBotaoCardapio" maxlength="60"
                       [(ngModel)]="configuracoes.rodapeBotaoCardapio" placeholder="Toque no botão para fazer seu pedido"/>
              </div>
            </div>
          </div>
            </ng-container>
            <ng-container *ngSwitchCase="'montagem'">


          <div class="mia-bloco">
            <fieldset class="mia-opcoes" [class.mia-oculto]="!chavesVisiveis.has('montagemProduto')">
              <legend class="mia-label"><i class="fas fa-sliders-h"></i> Produto com várias escolhas</legend>
              <p class="mia-hint mia-hint--escolha">Vale para produtos em que um grupo aceita mais de uma opção (duas proteínas,
                três acompanhamentos) ou com muitos grupos. Os demais continuam no chat, com lista e botões.
                Produtos com adicional que só aparece depois de outra escolha (ex.: bebida do combo) sempre vão para a página.</p>

              <div class="mia-chips">
                <label class="mia-opcao mia-opcao--chip" *ngFor="let opcao of opcoesMontagemProduto">
                  <input type="radio" class="mia-opcao__input" [id]="'rbMontagemProduto' + opcao.valor"
                         name="montagemProduto" [value]="opcao.valor"
                         [(ngModel)]="configuracoes.montagemProduto"/>
                  <span class="mia-opcao__corpo">
                    <span class="mia-opcao__marca"></span>
                    <span>
                      <span class="mia-opcao__nome"><i class="fas" [ngClass]="opcao.icone"></i> {{ opcao.nome }}</span>
                      <span class="mia-opcao__desc">{{ opcao.descricao }}<strong *ngIf="opcao.reforco"> {{ opcao.reforco }}</strong></span>
                    </span>
                  </span>
                  <span class="mia-dica" role="tooltip">{{ dicaDaOpcao(opcao) }}</span>
                </label>
              </div>
            </fieldset>


          </div>
<div class="mia-bloco mia-bloco--venda" *ngIf="configuracoes.carrinhoMiaV3"
               [class.mia-oculto]="!chavesVisiveis.has('upsellFechamento') && !chavesVisiveis.has('upsellItens')">
            <h3 class="mia-bloco__titulo">
              <i class="fas fa-gift"></i> Upsell (oferecer algo a mais)
              <span class="mia-selo-venda">vende mais</span>
              <span class="mia-bloco__estado" *ngIf="configuracoes.upsellFechamento">
                {{ produtosUpsell.length ? produtosUpsell.length + ' de 3 itens escolhidos' : 'modo automático' }}
              </span>
            </h3>
            <p class="mia-bloco__desc">Upsell é oferecer algo a mais na hora de fechar: sobremesa, bebida, acompanhamento. A Mia faz isso uma única vez, sem insistir.</p>

            <div class="mia-linha mia-linha--limpa">
              <div class="mia-linha__texto">
                <label for="upsellFechamento" class="mia-label"><i class="fas fa-plus-circle"></i> Upsell: oferecer um item a mais antes de fechar</label>
                <p class="mia-hint">Antes de perguntar entrega ou retirada, a Mia sugere um item que combina com o pedido.
                  Se o cliente aceitar, o item entra direto no carrinho com o preço do cardápio.</p>
              </div>
              <kendo-switch id="upsellFechamento" name="upsellFechamento"
                            [(ngModel)]="configuracoes.upsellFechamento" (ngModelChange)="atualizeBusca()"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>

            <ng-container *ngIf="configuracoes.upsellFechamento">
              <div class="mia-painel upsell-painel">
                <div class="upsell-escolha">
                  <div class="mia-linha__texto">
                    <label for="produtoUpsell" class="mia-label"><i class="fas fa-list-ul"></i> Itens que a Mia vai oferecer no upsell</label>
                    <p class="mia-hint">Escolha até 3 itens, na ordem em que a Mia deve preferir. Sem itens escolhidos,
                      ela decide sozinha: sugere o que os seus clientes mais pedem junto, com base nos pedidos dos últimos meses.</p>
                  </div>
                  <kendo-dropdownlist id="produtoUpsell" name="produtoUpsell" class="form-control upsell-busca"
                                      [data]="opcoesBuscaUpsell"
                                      [filterable]="true"
                                      [textField]="'descricao'" [valueField]="'id'"
                                      [disabled]="produtosUpsell.length >= 3"
                                      [(ngModel)]="produtoUpsellSelecionado"
                                      [defaultItem]="{id: null, descricao: produtosUpsell.length >= 3 ? 'Limite de 3 itens — remova um para trocar' : 'Buscar item do cardápio...'}"
                                      (valueChange)="adicioneProdutoUpsell($event)"
                                      (filterChange)="searchProdutoUpsell($event)"
                                      (focus)="busquePrimeiraVezUpsell()">
                  </kendo-dropdownlist>
                </div>

                <div class="upsell-cards" *ngIf="produtosUpsell.length; else upsellVazio">
                  <div class="upsell-card" *ngFor="let produto of produtosUpsell; let i = index"
                       [class.upsell-card--inelegivel]="produto.elegivel === false">
                    <span class="upsell-card__prioridade" title="Ordem de preferência">{{ i + 1 }}º</span>
                    <img class="upsell-card__foto" *ngIf="produto.imagem" [src]="produto.imagem" alt=""/>
                    <span class="upsell-card__foto upsell-card__foto--vazia" *ngIf="!produto.imagem" aria-hidden="true">
                      <i class="fas fa-utensils"></i>
                    </span>
                    <div class="upsell-card__info">
                      <strong class="upsell-card__nome">{{ produto.nome }}</strong>
                      <span class="upsell-card__meta">
                        <span class="upsell-card__preco" *ngIf="formatePrecoUpsell(produto.preco)">{{ formatePrecoUpsell(produto.preco) }}</span>
                        <span class="upsell-card__categoria" *ngIf="produto.categoria">{{ produto.categoria }}</span>
                      </span>
                      <span class="upsell-card__aviso" *ngIf="produto.elegivel === false">
                        <i class="fas fa-exclamation-triangle"></i>
                        Este item exige escolhas (tamanho ou adicionais) e será pulado — a oferta precisa caber em um toque.
                      </span>
                    </div>
                    <div class="upsell-card__acoes">
                      <button type="button" class="upsell-card__botao" *ngIf="i > 0"
                              (click)="subaPrioridadeUpsell(i)"
                              [attr.aria-label]="'Aumentar prioridade de ' + produto.nome">
                        <i class="fas fa-arrow-up"></i>
                      </button>
                      <button type="button" class="upsell-card__botao upsell-card__botao--remover"
                              (click)="removaProdutoUpsell(produto)"
                              [attr.aria-label]="'Remover ' + produto.nome">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <ng-template #upsellVazio>
                  <div class="upsell-vazio">
                    <span class="upsell-vazio__icone" aria-hidden="true"><i class="fas fa-magic"></i></span>
                    <div>
                      <strong class="upsell-vazio__titulo">Modo automático ligado</strong>
                      <p class="upsell-vazio__texto">A Mia analisa o que os seus clientes costumam pedir junto e sugere o
                        complemento com mais chance de agradar. Loja nova sem histórico? Ela oferece uma bebida ou
                        sobremesa que ainda não está no pedido.</p>
                    </div>
                  </div>
                </ng-template>

                <div class="upsell-preview" aria-hidden="true">
                  <p class="upsell-preview__rotulo"><i class="fab fa-whatsapp"></i> Como o cliente vê</p>
                  <div class="upsell-preview__chat">
                    <div class="upsell-preview__bolha">
                      <p class="upsell-preview__texto">Boa escolha! 😄 Que tal um <b>{{ exemploUpsell.nome }}</b> ({{ exemploUpsell.preco }}) pra acompanhar?</p>
                      <div class="upsell-preview__botoes">
                        <span class="upsell-preview__botao">Adicionar · {{ exemploUpsell.preco }}</span>
                        <span class="upsell-preview__botao">Não, só isso</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fechamento'">
        <div class="mia-bloco">
            <h3 class="mia-bloco__titulo"><i class="fas fa-map-marker-alt"></i> Dados do cliente</h3>

            <div class="mia-linha mia-linha--limpa" [class.mia-oculto]="!chavesVisiveis.has('pedirLocalizacao')">
              <div class="mia-linha__texto">
                <label for="pedirLocalizacao" class="mia-label"><i class="fas fa-map-marker-alt"></i> Pedir a localização no delivery</label>
                <p class="mia-hint">No fechamento com entrega, a Mia pede a localização 📍 do cliente para montar o
                  endereço. Desligado, ela pede o endereço digitado (rua, número e bairro). Se o cliente mandar a
                  localização por conta própria, ela continua sendo aproveitada.</p>
              </div>
              <kendo-switch id="pedirLocalizacao" name="pedirLocalizacao"
                            [(ngModel)]="configuracoes.pedirLocalizacao"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>

            <div class="mia-linha" *ngIf="configuracoes.carrinhoMiaV3"
                 [class.mia-oculto]="!chavesVisiveis.has('sugerirDadosHabituais')">
              <div class="mia-linha__texto">
                <label for="sugerirDadosHabituais" class="mia-label"><i class="fas fa-magic"></i> Sugerir os dados de sempre no fechamento</label>
                <p class="mia-hint">No fechamento, o endereço de sempre aparece em primeiro e marcado, o modo (entrega ou
                  retirada) e a forma de pagamento habituais vêm como primeira opção. Nada é escolhido sem o toque do cliente,
                  e o troco é perguntado toda vez.</p>
              </div>
              <kendo-switch id="sugerirDadosHabituais" name="sugerirDadosHabituais"
                            [(ngModel)]="configuracoes.sugerirDadosHabituais"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>

            <p class="mia-nota">
              <i class="fas fa-id-badge"></i>
              <span>A Mia reconhece quem já pediu na loja — pelo link ou pela conversa — e usa o histórico para atender
                mais rápido. Tudo aqui é sugestão: o que o cliente pedir na conversa vale mais que o costume.</span>
            </p>
          </div>
            </ng-container>
            <ng-container *ngSwitchCase="'equipe'">
<div class="mia-bloco" [class.mia-oculto]="!chavesVisiveis.has('escalarParaAtendente')
                 && !chavesVisiveis.has('mensagemEscalacao') && !chavesVisiveis.has('tempoPausaMia')">

            <div class="mia-linha mia-linha--limpa">
              <div class="mia-linha__texto">
                <label for="escalarParaAtendente" class="mia-label"><i class="fas fa-headset"></i> Deixar a Mia chamar uma pessoa da equipe</label>
                <p class="mia-hint">Quando o cliente pede para falar com um atendente, reclama de um pedido ou a Mia trava, a conversa vai
                  para a tela de conversas e alguém do time assume. Desligue se não há ninguém acompanhando o painel — assim a Mia
                  nunca promete um atendente que não vem.</p>
              </div>
              <kendo-switch id="escalarParaAtendente" name="escalarParaAtendente"
                            [(ngModel)]="configuracoes.escalarParaAtendente" (ngModelChange)="atualizeBusca()"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>


            <div class="mia-filhos">
              <div *ngIf="configuracoes.escalarParaAtendente">
                <label for="mensagemEscalacao" class="mia-label">Aviso ao cliente (opcional)</label>
                <p class="mia-hint">O que o cliente recebe no momento em que a conversa é passada para a equipe. Deixe em branco
                  para a Mia avisar com as palavras dela. Evite prometer prazo: ninguém sabe quando alguém vai assumir.</p>
                <textarea class="form-control" id="mensagemEscalacao" name="mensagemEscalacao" rows="2" maxlength="500"
                          [(ngModel)]="configuracoes.mensagemEscalacao"
                          placeholder="Ex.: Já passei sua mensagem para nossa equipe, alguém continua seu atendimento por aqui."></textarea>
              </div>

              <div>
                <div class="mia-linha">
                  <div class="mia-linha__texto">
                    <label for="tempoDePausaMia" class="mia-label">Tempo de pausa</label>
                    <p class="mia-hint">Prazo de retorno após uma pausa temporária, inclusive quando a equipe assume por conta própria. Carrinho em atendimento fica com a equipe até ser liberado.</p>
                  </div>
                  <div class="mia-numero">
                    <input type="number" class="form-control" id="tempoDePausaMia" name="tempoDePausaMia" kendoNumericTextBox
                           #tempoDePausaMia="ngModel" [(ngModel)]="configuracoes.tempoPausaMia" required="true" min="1"
                           maxlength="6" aria-describedby="tempoDePausaMiaEco"/>
                    <span class="mia-numero__sufixo">segundos</span>
                  </div>
                </div>
                <p class="mia-eco" id="tempoDePausaMiaEco">
                  <i class="far fa-clock"></i> A Mia fica <strong>{{ formatTime(configuracoes.tempoPausaMia) }}</strong> em silêncio numa pausa temporária.
                </p>
                <div class="mia-erro" *ngIf="frm.submitted || tempoDePausaMia.touched">
                  <span *ngIf="tempoDePausaMia.errors?.required">Informe o tempo de pausa.</span>
                  <span *ngIf="tempoDePausaMia.errors?.min">Use um tempo de pausa de pelo menos 1 segundo.</span>
                </div>
              </div>
            </div>
          </div>
            </ng-container>
            <ng-container *ngSwitchCase="'depois'">
<div class="mia-bloco mia-bloco--venda" *ngIf="configuracoes.carrinhoMiaV3"
               [class.mia-oculto]="!chavesVisiveis.has('followupMiaV3')
                 && !chavesVisiveis.has('toquesCarrinhoMinutos') && !chavesVisiveis.has('toquesDescobertaMinutos')">
            <h3 class="mia-bloco__titulo">
              <i class="fas fa-comment-dots"></i> Recuperar conversas paradas
              <span class="mia-selo-venda">recupera vendas</span>
            </h3>
            <p class="mia-bloco__desc">A Mia retoma automaticamente a conversa quando o cliente some no meio da compra.</p>

            <div class="mia-linha mia-linha--limpa">
              <div class="mia-linha__texto">
                <label for="followupMiaV3" class="mia-label"><i class="fas fa-bell"></i> Enviar lembretes proativos</label>
                <p class="mia-hint">A mensagem só sai com a Mia ativa, a loja recebendo pedidos e nenhuma resposta ou pedido novo.</p>
              </div>
              <kendo-switch id="followupMiaV3" name="followupMiaV3"
                            [(ngModel)]="configuracoes.followupMiaV3" (ngModelChange)="atualizeBusca()"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>

            <ng-container *ngIf="configuracoes.followupMiaV3">
              <div class="mia-painel">
                <div class="mia-linha mia-linha--empilha mia-linha--limpa">
                  <div class="mia-linha__texto">
                    <label class="mia-label"><i class="far fa-clock"></i> Toques do pedido parado</label>
                    <p class="mia-hint">Cliente que montou o pedido e sumiu recebe até 3 lembretes, contados de quando ele
                      parou de responder: o resumo com botões, um empurrãozinho com botão de fechar e um último aviso que
                      encerra de leve.</p>
                  </div>
                </div>
                <div class="mia-toques">
                  <ng-container *ngFor="let toque of toquesCarrinho; let i = index; trackBy: trackPorIndice">
                    <span class="mia-toques__seta" *ngIf="i > 0"><i class="fas fa-arrow-right"></i></span>
                    <div class="mia-toques__chip">
                      <input type="number" class="form-control" [name]="'toqueCarrinho' + i" kendoNumericTextBox
                             [(ngModel)]="toquesCarrinho[i]" required="true" [min]="1" [max]="60"/>
                      <span class="mia-numero__sufixo">min</span>
                      <button type="button" class="mia-toques__remover" *ngIf="toquesCarrinho.length > 1"
                              (click)="removaToque(toquesCarrinho, i)" title="Remover este toque">&times;</button>
                    </div>
                  </ng-container>
                  <button type="button" class="mia-toques__adicionar" *ngIf="toquesCarrinho.length < 3"
                          (click)="adicioneToque(toquesCarrinho)">+ adicionar toque</button>
                </div>
                <div class="mia-erro" *ngIf="!escadaValida(toquesCarrinho)">
                  <span>Use tempos crescentes entre 1 e 60 minutos.</span>
                </div>
                <div class="upsell-preview" aria-hidden="true">
                  <p class="upsell-preview__rotulo"><i class="fab fa-whatsapp"></i> Como o cliente vê</p>
                  <div class="upsell-preview__chat mia-thread">
                    <ng-container *ngFor="let toque of toquesCarrinho; let i = index; trackBy: trackPorIndice">
                      <p class="mia-thread__marcador">{{ marcadorDoToque(toquesCarrinho, i) }}</p>
                      <div class="upsell-preview__bolha">
                        <ng-container *ngIf="i === 0; else textoDoToqueCarrinho">
                          <p class="upsell-preview__texto">Oi! Seu pedido ficou quase pronto aqui 😊<br><b>Total: R$ 38,00</b><br>Quer fechar?</p>
                          <div class="upsell-preview__botoes">
                            <span class="upsell-preview__botao">Fechar pedido ✅</span>
                            <span class="upsell-preview__botao">Adicionar mais</span>
                          </div>
                        </ng-container>
                        <ng-template #textoDoToqueCarrinho>
                          <p class="upsell-preview__texto">{{ previewToquesCarrinho[i] }}</p>
                          <div class="upsell-preview__botoes" *ngIf="i === 1">
                            <span class="upsell-preview__botao">Fechar pedido ✅</span>
                          </div>
                        </ng-template>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="mia-linha mia-linha--empilha mia-linha--limpa mia-toques__separador">
                  <div class="mia-linha__texto">
                    <label class="mia-label"><i class="far fa-comment"></i> Toques da conversa</label>
                    <p class="mia-hint">Cliente que só conversou, sem itens no carrinho, recebe toques mais leves — e menos
                      insistentes.</p>
                  </div>
                </div>
                <div class="mia-toques">
                  <ng-container *ngFor="let toque of toquesDescoberta; let i = index; trackBy: trackPorIndice">
                    <span class="mia-toques__seta" *ngIf="i > 0"><i class="fas fa-arrow-right"></i></span>
                    <div class="mia-toques__chip">
                      <input type="number" class="form-control" [name]="'toqueDescoberta' + i" kendoNumericTextBox
                             [(ngModel)]="toquesDescoberta[i]" required="true" [min]="1" [max]="60"/>
                      <span class="mia-numero__sufixo">min</span>
                      <button type="button" class="mia-toques__remover" *ngIf="toquesDescoberta.length > 1"
                              (click)="removaToque(toquesDescoberta, i)" title="Remover este toque">&times;</button>
                    </div>
                  </ng-container>
                  <button type="button" class="mia-toques__adicionar" *ngIf="toquesDescoberta.length < 3"
                          (click)="adicioneToque(toquesDescoberta)">+ adicionar toque</button>
                </div>
                <div class="mia-erro" *ngIf="!escadaValida(toquesDescoberta)">
                  <span>Use tempos crescentes entre 1 e 60 minutos.</span>
                </div>
                <div class="upsell-preview" aria-hidden="true">
                  <p class="upsell-preview__rotulo"><i class="fab fa-whatsapp"></i> Como o cliente vê</p>
                  <div class="upsell-preview__chat mia-thread">
                    <ng-container *ngFor="let toque of toquesDescoberta; let i = index; trackBy: trackPorIndice">
                      <p class="mia-thread__marcador">{{ marcadorDoToque(toquesDescoberta, i) }}</p>
                      <div class="upsell-preview__bolha">
                        <p class="upsell-preview__texto">{{ previewToquesConversa[i] }}</p>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
            </ng-container>
            <ng-container *ngSwitchCase="'legado'">
<div class="mia-bloco">

            <div class="mia-linha mia-linha--limpa" [class.mia-oculto]="!chavesVisiveis.has('responderSobreProdutos')">
              <div class="mia-linha__texto">
                <label for="responderSobreProdutos" class="mia-label"><i class="fas fa-utensils"></i> Responder sobre produtos do cardápio</label>
                <p class="mia-hint">A Mia usa o cardápio para falar de itens, preços e disponibilidade.</p>
              </div>
              <kendo-switch id="responderSobreProdutos" name="responderSobreProdutos"
                            [(ngModel)]="configuracoes.responderSobreProdutos"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>



            <fieldset class="mia-opcoes" [class.mia-oculto]="!chavesVisiveis.has('comportamentoForaDoEscopo')">
              <legend class="mia-label"><i class="fas fa-question-circle mia-opcoes__icone"></i> Perguntas fora do escopo</legend>
              <p class="mia-hint mia-hint--escolha">O que a Mia faz quando perguntam algo que não é do atendimento.</p>

              <div class="mia-chips">
                <label class="mia-opcao mia-opcao--chip" *ngFor="let opcao of opcoesForaDoEscopo">
                  <input type="radio" class="mia-opcao__input" [id]="'rbEscopo' + opcao.valor"
                         name="comportamentoForaDoEscopo" [value]="opcao.valor"
                         [(ngModel)]="configuracoes.comportamentoForaDoEscopo"/>
                  <span class="mia-opcao__corpo">
                    <span class="mia-opcao__marca"></span>
                    <span>
                      <span class="mia-opcao__nome"><i class="fas" [ngClass]="opcao.icone"></i> {{ opcao.nome }}</span>
                      <span class="mia-opcao__desc">{{ opcao.descricao }}<strong *ngIf="opcao.reforco"> {{ opcao.reforco }}</strong></span>
                    </span>
                  </span>
                  <span class="mia-dica" role="tooltip">{{ dicaDaOpcao(opcao) }}</span>
                </label>
              </div>

              <p class="mia-escolhido" *ngIf="opcaoForaDoEscopo">
                <span>{{ opcaoForaDoEscopo.descricao }}<strong *ngIf="opcaoForaDoEscopo.reforco"> {{ opcaoForaDoEscopo.reforco }}</strong></span>
              </p>
            </fieldset>
          </div>
<section class="mia-bloco mia-bloco--legado"
                   [class.mia-oculto]="!chavesVisiveis.has('recuperarCarrinho') && !chavesVisiveis.has('tempoRecuperarCarrinho')">
            <button type="button" class="mia-bloco__head" (click)="alterneBloco('legado')"
                    [attr.aria-expanded]="blocosAbertos.legado" aria-controls="mia-bloco-legado">
              <span class="mia-bloco__badge"><i class="fas fa-shopping-basket"></i></span>
              <span class="mia-bloco__txt">
                <span class="mia-bloco__nome">Carrinho do cardápio digital <span class="mia-tag mia-tag--legado">legado</span></span>
                <span class="mia-bloco__resumo">{{ resumoLegado }}</span>
              </span>
              <i class="fas fa-chevron-down mia-bloco__chevron"></i>
            </button>

            <div class="mia-bloco__corpo" id="mia-bloco-legado"
                 [class.mia-bloco__corpo--fechado]="!blocosAbertos.legado">
              <p class="mia-hint mia-hint--legado">Um lembrete para quem montou o pedido e não finalizou. Vale para o bot
                anterior: com a Mia V3 atendendo, quem manda os lembretes é <strong>Recuperar conversas paradas</strong>,
                logo acima.</p>

              <div class="mia-linha mia-linha--limpa">
                <div class="mia-linha__texto">
                  <label for="recuperarCarrinho" class="mia-label"><i class="fas fa-bell"></i> Lembrar cliente do carrinho abandonado</label>
                  <p class="mia-hint">A Mia manda uma mensagem depois do tempo que você definir, para trazer o cliente de volta.</p>
                </div>
                <kendo-switch id="recuperarCarrinho" name="recuperarCarrinho" [(ngModel)]="configuracoes.recuperarCarrinho" (ngModelChange)="atualizeBusca()"
                              [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
              </div>

              <ng-container *ngIf="configuracoes.recuperarCarrinho">
                <div class="mia-painel">
                  <div class="mia-linha mia-linha--empilha mia-linha--limpa">
                    <div class="mia-linha__texto">
                      <label for="tempoRecuperarCarrinho" class="mia-label"><i class="fas fa-hourglass-half"></i> Esperar antes de enviar</label>
                      <p class="mia-hint">Tempo suficiente para o cliente decidir, curto o bastante para não perder a oportunidade.</p>
                    </div>
                    <div class="mia-numero">
                      <input type="number" class="form-control" id="tempoRecuperarCarrinho" name="tempoRecuperarCarrinho"
                             kendoNumericTextBox #tempoRecuperarCarrinho="ngModel"
                             [(ngModel)]="configuracoes.tempoRecuperarCarrinho" required="true" min="1" maxlength="6"
                             aria-describedby="tempoRecuperarCarrinhoEco"/>
                      <span class="mia-numero__sufixo">segundos</span>
                    </div>
                  </div>
                  <p class="mia-eco" id="tempoRecuperarCarrinhoEco">
                    <i class="far fa-clock"></i> A mensagem sai <strong>{{ formatTime(configuracoes.tempoRecuperarCarrinho) }}</strong> depois do carrinho parado.
                  </p>
                  <div class="mia-erro" *ngIf="frm.submitted || tempoRecuperarCarrinho.touched">
                    <span *ngIf="tempoRecuperarCarrinho.errors?.required">Informe o tempo de espera.</span>
                    <span *ngIf="tempoRecuperarCarrinho.errors?.min">Use um tempo de espera de pelo menos 1 segundo.</span>
                  </div>
                </div>

                <div class="mia-subsecao">
                  <h3 class="mia-subsecao__titulo">Mensagem enviada</h3>
                  <app-form-notificacao [notificacao]="notificacao"></app-form-notificacao>
                </div>
              </ng-container>
            </div>
          </section>
<section class="mia-bloco mia-bloco--legado" *ngIf="ehAdminMeuCardapio"
                   [class.mia-oculto]="!chavesVisiveis.has('usarFluxoTypebot')">
            <button type="button" class="mia-bloco__head" (click)="alterneBloco('fluxo')"
                    [attr.aria-expanded]="blocosAbertos.fluxo" aria-controls="mia-bloco-fluxo">
              <span class="mia-bloco__badge"><i class="fas fa-layer-group"></i></span>
              <span class="mia-bloco__txt">
                <span class="mia-bloco__nome">Fluxo de conversas <span class="mia-tag mia-tag--legado">legado</span></span>
                <span class="mia-bloco__resumo">{{ resumoFluxo }}</span>
              </span>
              <i class="fas fa-chevron-down mia-bloco__chevron"></i>
            </button>

            <div class="mia-bloco__corpo" id="mia-bloco-fluxo"
                 [class.mia-bloco__corpo--fechado]="!blocosAbertos.fluxo">
              <p class="mia-hint mia-hint--legado">Um menu guiado antes da Mia assumir a conversa. Não é lido pelo caminho
                da Mia V3.</p>

              <div class="mia-linha mia-linha--limpa">
                <div class="mia-linha__texto">
                  <label for="usarFluxoTypebot" class="mia-label"><i class="fas fa-project-diagram"></i> Usar fluxo de conversas</label>
                  <p class="mia-hint">O cliente escolhe o que quer em um menu e a Mia continua a partir dali.</p>
                </div>
                <kendo-switch id="usarFluxoTypebot" name="usarFluxoTypebot" [(ngModel)]="configuracoes.usarFluxoTypebot"
                              [onLabel]="'Sim'" [offLabel]="'Não'"
                              (valueChange)="onUsarFluxoTypebotChange($event)"></kendo-switch>
              </div>

              <ng-container *ngIf="configuracoes.usarFluxoTypebot">
                <button type="button" class="mia-link mia-link--bloco" (click)="mostrarFluxoPadrao = !mostrarFluxoPadrao"
                        [attr.aria-expanded]="mostrarFluxoPadrao" aria-controls="mia-fluxo-padrao">
                  Como funciona o fluxo padrão
                  <i class="fas" [ngClass]="mostrarFluxoPadrao ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>

                <div class="mia-painel mia-fluxo" id="mia-fluxo-padrao" *ngIf="mostrarFluxoPadrao">
                  <p class="mia-hint">A conversa abre com quatro opções:</p>
                  <ul class="mia-fluxo__menu">
                    <li><span class="mia-fluxo__emoji">🛍️</span><strong>Fazer pedido</strong> — inicia um pedido e coleta os dados.</li>
                    <li><span class="mia-fluxo__emoji">📱</span><strong>Ver cardápio</strong> — leva o cliente ao cardápio digital.</li>
                    <li><span class="mia-fluxo__emoji">❓</span><strong>Tirar dúvida</strong> — responde as perguntas frequentes.</li>
                    <li><span class="mia-fluxo__emoji">👤</span><strong>Falar com atendente</strong> — chama uma pessoa da equipe.</li>
                  </ul>

                  <p class="mia-fluxo__legenda">Ao escolher "Fazer pedido", a Mia segue esta ordem:</p>
                  <ol class="mia-fluxo__etapas">
                    <li>
                      <span class="mia-fluxo__num">1</span>
                      <span><strong>Forma de entrega</strong><small>Entrega ou retirada</small></span>
                    </li>
                    <li>
                      <span class="mia-fluxo__num">2</span>
                      <span><strong>Localização</strong><small>Endereço de entrega</small></span>
                    </li>
                    <li>
                      <span class="mia-fluxo__num">3</span>
                      <span><strong>Forma de pagamento</strong><small>Método e troco</small></span>
                    </li>
                    <li class="mia-fluxo__fim">
                      <span class="mia-fluxo__num"><i class="fas fa-arrow-right"></i></span>
                      <span><strong>Cardápio digital</strong><small>Cliente finaliza o pedido</small></span>
                    </li>
                  </ol>
                </div>

                <div class="mia-vazio" *ngIf="!configuracoes.typebotConfigurado && !criandoFluxosTypebot">
                  <p>Os fluxos ainda não foram criados para esta loja.</p>
                  <button type="button" class="btn btn-primary" (click)="abrirTelaConfigTypebot()">
                    <i class="fas fa-cogs"></i> Ativar fluxos de conversas
                  </button>
                </div>

                <div class="mia-vazio" *ngIf="criandoFluxosTypebot">
                  <span class="mia-spinner"></span>
                  <p>Criando os fluxos de conversas…</p>
                </div>

                <div class="mia-canais" *ngIf="configuracoes.typebotConfigurado">
                  <div class="mia-canal">
                    <span class="mia-canal__icone mia-canal__icone--whatsapp"><i class="fab fa-whatsapp"></i></span>
                    <div class="mia-canal__texto">
                      <strong>WhatsApp</strong>
                      <small>Fluxo ativo neste canal</small>
                    </div>
                    <button type="button" class="btn btn-outline-primary btn-sm"
                            (click)="editarFluxoTypebot('whatsapp', 'WhatsApp')">Editar fluxo</button>
                  </div>

                  <div class="mia-canal" *ngIf="false">
                    <span class="mia-canal__icone mia-canal__icone--instagram"><i class="fab fa-instagram"></i></span>
                    <div class="mia-canal__texto">
                      <strong>Instagram</strong>
                      <small>Fluxo ativo neste canal</small>
                    </div>
                    <button type="button" class="btn btn-outline-primary btn-sm"
                            (click)="editarFluxoTypebot('instagram', 'Instagram')">Editar fluxo</button>
                  </div>
                </div>
              </ng-container>
            </div>
          </section>
            </ng-container>
            <ng-container *ngSwitchCase="'motor'">
<div class="mia-bloco">
            <p class="mia-bloco__desc">A vendedora conversacional que assume a venda no WhatsApp oficial.</p>

            <label class="mia-chave" for="chkUsarMiaV3" [class.mia-chave--ligada]="configuracoes.usarMiaV3">
              <span class="mia-chave__icone"><i class="fas fa-robot"></i></span>
              <span class="mia-chave__texto">
                <strong>Atender pela Mia V3</strong>
                <small>Substitui o bot antigo no WhatsApp oficial.</small>
              </span>
              <input type="checkbox" class="mia-chave__input" id="chkUsarMiaV3" name="usarMiaV3"
                     [(ngModel)]="configuracoes.usarMiaV3" (ngModelChange)="atualizeBusca()"/>
              <span class="mia-chave__trilho"><span class="mia-chave__botao"></span></span>
            </label>

            <label class="mia-chave" for="chkCarrinhoMiaV3" [class.mia-chave--ligada]="configuracoes.carrinhoMiaV3">
              <span class="mia-chave__icone"><i class="fas fa-shopping-cart"></i></span>
              <span class="mia-chave__texto">
                <strong>Carrinho conversacional</strong>
                <small>Monta o pedido e fecha a venda no chat. Sem ele, a Mia V3 só tira dúvidas e direciona ao cardápio.</small>
                <small class="mia-chave__consequencia">Desligado, somem os ajustes de conversa curta, repetir pedido,
                  dados de sempre, item a mais e lembretes proativos.</small>
              </span>
              <input type="checkbox" class="mia-chave__input" id="chkCarrinhoMiaV3" name="carrinhoMiaV3"
                     [(ngModel)]="configuracoes.carrinhoMiaV3" (ngModelChange)="onCarrinhoMiaV3Change()"/>
              <span class="mia-chave__trilho"><span class="mia-chave__botao"></span></span>
            </label>

            <div class="mia-campo mia-campo--folga">
              <label for="modelo-ia-v3" class="mia-label mia-label--cap">Modelo de IA</label>
              <select class="form-control" id="modelo-ia-v3" name="modeloIaV3" [(ngModel)]="configuracoes.modeloIaV3">
                <option *ngFor="let modelo of modelosIa" [ngValue]="modelo.valor">{{ modelo.rotulo }}</option>
              </select>
              <p class="mia-hint">Motor inteligente responsável por interpretar dúvidas do cardápio e sugestões.</p>
            </div>



          </div>

            </ng-container>
          </ng-container>
        </section>

        <div class="mia-vazio mia-vazio--busca" *ngIf="buscando && !totalEncontrado && !resultadosBloqueados.length">
          <span class="mia-vazio__icone" aria-hidden="true"><i class="fas fa-search"></i></span>
          <p>Nenhum ajuste combina com <strong>“{{ busca }}”</strong>.</p>
          <button type="button" class="mia-link" (click)="limpeBusca()">Limpar a busca</button>
        </div>
      </div>
    </div>
    </div>

    <!-- Barra de ações fixa: salvar sempre ao alcance -->
    <div class="mia-acoes">
      <div class="mia-acoes__estado">
        <span class="mia-pill" [attr.data-estado]="estadoAtual.chave">
          <span class="mia-pill__dot"></span>{{ estadoAtual.rotulo }}
        </span>
        <span class="mia-acoes__msg" *ngIf="msgSucesso"><i class="mdi mdi-check-all"></i> {{ msgSucesso }}</span>
      </div>
      <div class="mia-acoes__botoes">
        <button type="reset" class="btn btn-light">Cancelar</button>
        <button type="submit" class="btn btn-primary">Salvar alterações</button>
      </div>
    </div>
  </form>
</div>
